import { render, staticRenderFns } from "./ShimmerEffect.vue?vue&type=template&id=4148d6f6&scoped=true"
import script from "./ShimmerEffect.vue?vue&type=script&lang=js"
export * from "./ShimmerEffect.vue?vue&type=script&lang=js"
import style0 from "./ShimmerEffect.vue?vue&type=style&index=0&id=4148d6f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4148d6f6",
  null
  
)

export default component.exports